import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldNumberComponent } from './field-number.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';



@NgModule({
  declarations: [
    FieldNumberComponent
  ],
  exports: [
    FieldNumberComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class FieldNumberModule { }
